import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './Styles.module.css';
import strings from '../../globalization';

const MdmPopup = props => {
  const { startTimer, closeApp } = props;

  const [mdmTimer, setMdmTimer] = useState(0);
  let mdmTimerInterval = null;

  useEffect(() => {
    if (startTimer) {
      startMDMTimer();
    }
  }, [startTimer]);

  const startMDMTimer = () => {
    clearInterval(mdmTimerInterval);
    let newTimer = 30;
    setMdmTimer(newTimer);
    mdmTimerInterval = setInterval(() => {
      if (newTimer <= 0) {
        stopMDMTimer();
        closeApp && closeApp(true);
      }
      newTimer--;
      setMdmTimer(newTimer);
    }, 1000);
  };

  const stopMDMTimer = () => {
    clearInterval(mdmTimerInterval);
    setMdmTimer(0);
  };

  return (
    <div>
      <div className={styles.headerWrapper}>
        <span className={styles.headingTxt}>MDM POLICY UPDATE</span>
        {mdmTimer && mdmTimer > 0 ? <span className={styles.timer}>{mdmTimer}</span> : null}
      </div>
      <div className={styles.bodyWrapper}>
        <div className={styles.message}>{strings.mdmPolicyChangedMsg}</div>
        <div className={styles.btnWrapper}>
          <button className={styles.btn} onClick={() => closeApp(true)}>{strings.closeApp}</button>
        </div>
      </div>
    </div>
  );
};


const DevicePopup = props => {
  const { onClose, deviceName, note } = props;
  const storeInfo = useSelector(state => state?.storeInfo?.data);

  const storeName = storeInfo?.name;
  const address =
    `${storeInfo?.address1 ? storeInfo?.address1 : ' '} 
    ${storeInfo?.address2 ? storeInfo?.address2 : ' '} 
    ${storeInfo?.city ? storeInfo?.city : ' '} 
    ${storeInfo?.state ? storeInfo?.state : ' '} 
    - ${storeInfo?.zipCode ? storeInfo?.zipCode : ' '}`;

  return (
    <div>
      <div className={styles.headerWrapper}>
        <span className={styles.headingTxt}>System Alert</span>
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.labelTxt}>Store Name: <span className={styles.valueTxt}>{storeName}</span></div>
        <div className={styles.labelTxt}>Device Name: <span className={styles.valueTxt}>{deviceName}</span></div>
        <div className={styles.labelTxt}>Store Address: <span className={styles.valueTxt}>{address}</span></div>
        <div className={styles.noteTxt}>{note}</div>
        <div className={styles.btnWrapper}>
          <button className={styles.btn} onClick={onClose}>{strings.ok}</button>
        </div>
      </div>
    </div>
  );
};

export { MdmPopup, DevicePopup };